import React from 'react'

const DragDropOverlay = ({ sendButtonColor, }) => {
    return (
        <div
            className="absolute inset-0 flex flex-col items-center justify-center z-[100] pointer-events-none rounded-lg bg-white/90"
            style={{
                border: `2px dashed ${sendButtonColor}`,
            }}
        >
            <svg
                className="w-12 h-12 mb-3 opacity-90"
                style={{ color: sendButtonColor }}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                />
            </svg>
            <p
                className="text-base font-medium text-center"
                style={{ color: sendButtonColor }}
            >
                Add Anything
            </p>
            <p className="text-xs text-gray-500 mt-1">
                Drop your file here to add it to the conversation
            </p>
        </div>
    )
}

export default DragDropOverlay